import { matchPath } from "react-router-dom";

export function isForcedAllTenantRoute(pathname: string) {
  return (
    matchPath("/live/events/overview", pathname) != null ||
    matchPath("/live/events/:eventId/overview", pathname) != null
  );
}
